function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { forwardRef, useCallback, useState } from 'react';
import { LoadingIndicator } from '@arc/frontend/ui-graphics';
import { Button } from './Button';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1pjdep4-ButtonWithLoading",
  styles: "position:relative;label:ButtonWithLoading;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "vig1n7",
  styles: "position:absolute;inset:0 0 0 0"
} : {
  name: "1m8hgqb-ButtonWithLoading",
  styles: "position:absolute;inset:0 0 0 0;label:ButtonWithLoading;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
/**
 * Button that is disabled and shows loading spinner while waiting for its
 * `onClick` to finish.
 *
 * `onClick` will not be called again until its previous call is finished.
 */
export const ButtonWithLoading = forwardRef(function ButtonWithLoading(props, ref) {
  const {
    onClick: propsOnClick,
    loading: propsLoading = false,
    children,
    ...forwardedProps
  } = props;

  /**
   * It's safe to use a `useState` and the button's `disabled` attribute to
   * prevent multiple simultaneous calls to `onClick`.
   *
   * We do not need to worry about `onClick` being called multiple times before
   * the button is updated to disabled. (The button's onClick will not be
   * called while its disabled attribute is true.)
   *
   * According to https://github.com/reactwg/react-18/discussions/21
   *
   * > Note: React only batches updates when it's generally safe to do. For
   * > example, React ensures that for each user-initiated event like a click or
   * > a keypress, the DOM is fully updated before the next event. This ensures,
   * > for example, that a form that disables on submit can’t be submitted
   * > twice.
   */
  const [stateLoading, setLoading] = useState(false);
  const loading = propsLoading || stateLoading;
  const onClick = useCallback(async event => {
    try {
      setLoading(true);
      await propsOnClick?.(event);
    } finally {
      setLoading(false);
    }
  }, [propsOnClick]);
  return <Button {...forwardedProps} ref={ref} disabled={loading || forwardedProps.disabled}
  // @ts-expect-error `data-*` attributes are not in the type definition
  data-disabled={loading || forwardedProps['data-disabled']} onClick={onClick} css={_ref}>
			{children}
			{loading ? <LoadingIndicator color={forwardedProps.variant === 'contained' ? 'white' : undefined} css={_ref2} /> : null}
		</Button>;
});